import { useState } from 'react';
import { refundRequestService } from '../../services/invoiceService';
const useRefundRequest = () => {
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const resetRefundState = () => {
    setSuccess(false);
    setLoading(false);
    setError(null);
  };

  const refundRequest = async (payload = {}) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await refundRequestService(payload);
      setSuccess(true);
    } catch (err) {
        setSuccess(false);

      if (err.response) {
        setError(`${err.response.data.message}`);
      } else if (err.request) {
        setError('No response from server');
      } else {
        setError(`${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return { success, loading, error, refundRequest, resetRefundState };
};

export default useRefundRequest;
